"use client";
import { Modal, type ModalProps } from "@offstreetparking/design-system/overlay";
import { useFlowOverlayContainment } from "../../../host/overlay-containment";
import { ContainedOverlay } from "../ContainedOverlay/ContainedOverlay";

export const FlowModal = (props: ModalProps) => {
	const contained = useFlowOverlayContainment();
	if (!contained) {
		return <Modal {...props} />;
	}
	return (
		<ContainedOverlay
			isOpen={props.isOpen}
			onClose={() => {
				props.onClose?.();
				props.onAnimationComplete?.();
			}}
			closeLabel={props.i18n.closeButton}
			actions={props.actions}
		>
			{props.children}
		</ContainedOverlay>
	);
};
